<template>
  <!-- 动态表单 start -->

  <van-form validate-first submit-on-enter @submit="onSubmit">
    <template v-for="(item, index) in formItems">
      <van-field
        v-if="item.itemType === 'input'"
        :key="index"
        v-model="formData[item.prop]"
        :rules="rules ? rules[item.prop]:[]"
        :type="item.type"
        :name="item.name"
        :autofocus="item.autofocus"
        :maxlength="item.maxlength"
        :label="item.label"
        :placeholder="item.placeholder"
      />

      <template v-else-if="item.itemType === 'slot'">
        <slot :name="'formSlot' + index"/>
      </template>
    </template>
    <!-- 表单按钮 -->
    <slot name="formBtn"/>
  </van-form>

  <!-- 动态表单 end -->
</template>

<script>
import { Image as VanImage, Button, Form, Field, Overlay } from 'vant';
export default {
  name: 'CForm',
  components: {
    [VanImage.name]: VanImage,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Overlay.name]: Overlay
  },
  props: {
    /**
     * 表单项配置
     */
    formItems: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => {}
    },
    /**
     * 表单数据
     */
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  watch: {
    // formItems: {
    //   // 监听数据变化
    //   handler(val) {
    //     this.formItems = val;
    //     this.init();
    //   },
    //   deep: true
    // }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      console.log('rules:', this.rules);
    },
    onSubmit(values) {
      console.log('submit', values);
      this.$emit('submit', values);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/global/c-form.vue